import { useState } from "react";
import { Button, Flex } from "@theorgchartdev/storybook";
import PhoneChartSearch from "./PhoneChartSearch";
import AgentViewToggle from "../../Blocks/Composites/AgentViewToggle/AgentViewToggle";
import ViewMenu from "../../Blocks/Menus/ViewMenu/ViewMenu";
import { ProfileCardHost } from "../MainToolbar/ProfileToolbarAction";
import { Globals } from "@coreapp/CoreApp/Globals";
import { useAppReady } from "@/hooks/useAppReady";
import { usePermissionCheck } from "@/hooks/usePermissionCheck";
import { usePhoneEscapePopoverProps } from "@/hooks/usePhoneEscapePopoverProps";
import { appstr } from "@coreapp/utils/appstr";

// Bottom-pinned toolbar for phone layout: search, view switcher, Agent View.
const PhoneToolbar = () => {
  const appReady = useAppReady();
  const { showViews } = usePermissionCheck();
  const [searchOpen, setSearchOpen] = useState(false);
  const escapePopoverProps = usePhoneEscapePopoverProps();

  if (!appReady) {
    return <div className="ocn-phone-toolbar" />;
  }

  const showSearchAction = Globals._uiConfig?.fHasSearch;
  const bar = (
    <Flex className="ocn-phone-toolbar" alignItems="center" gap="12px" padding="8px 16px">
      {showSearchAction && (
        <Button
          iconOnly
          modifier="secondary"
          size="medium"
          iconProps={{ name: "search" }}
          ariaLabel={appstr("Search")}
          onClick={() => setSearchOpen(true)}
          dataTestId="phone-toolbar-search"
        />
      )}
      <Flex alignItems="center" gap="12px" className="ocn-phone-toolbar-end">
        {showViews && (
          // Bottom-pinned bar: open upward and never flip down off-screen.
          <ViewMenu
            position="top-start"
            popoverProps={{ ...escapePopoverProps, flipOptions: { mainAxis: false } }}
          />
        )}
        <AgentViewToggle />
      </Flex>
    </Flex>
  );

  return (
    <>
      {searchOpen ? <PhoneChartSearch onClose={() => setSearchOpen(false)} /> : bar}
      {/* The bar has no profile button; the box click toolbar opens the card. */}
      <ProfileCardHost />
    </>
  );
};

export default PhoneToolbar;
